<template>
  <div
    class="business-intelligence-badge-competitor-menu"
    @mouseenter="iconHover = true"
    @mouseleave="iconHover = false"
  >
    <BaseRoundButton
      v-if="getIcon()"
      isTransparent
      isNeutral
      :tooltip-text="
        isExistingCompetitor
          ? $t('page.business-intelligence.badge.competitor-menu.remove')
          : $t('page.business-intelligence.badge.competitor-menu.add')
      "
      :icon="getIcon()"
      :size="18"
      @click.native.stop="isExistingCompetitor ? onRemoveCompetitorClicked() : onAddCompetitorClicked()"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';
import { normalizeStr } from '@/util/string-util';

export default {
  name: 'BIBadgeCompetitorMenu',
  components: { BaseRoundButton },
  data: () => ({
    iconHover: false,
  }),
  props: {
    name: {
      type: String,
      default: '',
    },
    isExistingCompetitor: {
      type: Boolean,
      default: false,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('biDashboard', ['competitors']),
  },
  methods: {
    ...mapActions('biDashboard', ['getAllCompetitors', 'addCompetitor', 'deleteCompetitor']),
    getIcon() {
      if (this.isExistingCompetitor) {
        return this.iconHover ? 'bookmark-filled-remove' : 'bookmark-filled-check';
      } else if (!this.isExistingCompetitor) {
        if (this.hover === true && this.iconHover === false) {
          return 'bookmark-add';
        } else if (this.iconHover) {
          return 'bookmark-check';
        }
      }
    },
    onAddCompetitorClicked() {
      if (!this.isExistingCompetitor) {
        this.addCompetitor({ name: this.name.trim(), normalizedNames: [normalizeStr(this.name.trim(), ' ')] })
          .then(() => {
            this.$toast.success(this.$tc('page.business-intelligence.competitor.add-dialog.add-success'));
            this.$emit('action-succeeded');
          })
          .catch((error) => this.$toast.error(error));
      }
    },
    onRemoveCompetitorClicked() {
      const existingCompetitor = this.competitors.find((c) => {
        return c.competitorNames.some((name) => normalizeStr(name.normalizedName) === normalizeStr(this.name));
      });

      if (existingCompetitor) {
        this.deleteCompetitor(existingCompetitor.id)
          .then(() => {
            this.$toast.success(this.$tc('page.business-intelligence.competitor.delete-dialog.delete-success'));
            this.$emit('action-succeeded');
          })
          .catch((error) => this.$toast.error(error));
      } else {
        console.error('Unknown competitor');
      }
    },
  },
};
</script>

<style lang="scss">
.business-intelligence-badge-competitor-menu {
  display: flex;
  justify-content: center;

  .base-round-button {
    .base-icon {
      width: 18px;
      height: 18px;
      color: $color-normal !important;
    }

    // Phones: its 18px take taps over the badge's bottom corner. The badge's ⋯
    // (BIBadgeActionMenu) sits 22px above it, so each keeps its side of the space between them.
    @include screen-below('tablet') {
      &::after {
        content: '';
        position: absolute;
        inset: -2px -14px -13px;
      }
    }
  }
}
</style>
